import { useKeycloak } from 'auth/keycloak';
import useAxios from 'axios-hooks';
import config from 'config';
import { useAppContext } from 'context/appContext';
const url: string = config.api.url;

const useDeleteUser = () => {
  const {
    settings: { routeIssuer },
  } = useAppContext();
  const { keycloak } = useKeycloak();

  keycloak
    .updateToken(5)
    .then(() => {
      localStorage.setItem('kc_token', keycloak.token);
      localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
    })
    .catch(() => keycloak.login());

  const [{ error, loading }, removeUser] = useAxios({
    method: 'POST',
    headers: { 'X-Prisma-Issuer': routeIssuer, Authorization: `Bearer ${keycloak.token}`, 'backoffice-source': routeIssuer },
  });

  return {
    deleteUser: (id: string) => removeUser({ url: `${url}/v1/users/${id}/delete` }),
    isLoading: loading,
    isError: error,
  };
};

export default useDeleteUser;
